import {
	BookingProgress,
	BookingStep,
	BookingStepNavigation,
	useStepDependencies,
} from '@/features/booking'
import { LocationStep } from '@/features/location'
import { RoomConfigurationStep } from '@/features/room-config'
import { RoomSelectionStep } from '@/features/room-selection'
import { TravelPeriodStep } from '@/features/travel-period'
import { useAppInit } from '@/hooks/useAppInit'
import { AppConfigProps } from '@/stores/app-store-config/types'

import { GuestDataStep } from './features/guest-data'
import { useCancelReservation } from './features/reservation'
import { useScrollSnapping } from './features/scrolling'
import { useUrlQUery } from './features/url-handling'
import { Footer } from './layout/footer'
import { Hero } from './layout/hero'
import './main.css'
import { useAppConfigStore } from './stores/app-store-config/appConfigStore'
import { translate } from './utils/translator'

export const App = (props: AppConfigProps) => {
	const { isStoreRdy } = useAppInit(props)
	const image = useAppConfigStore.use.image()
	const heroTitle = useAppConfigStore.use.heroTitle?.()

	useUrlQUery()
	useCancelReservation()
	useScrollSnapping()
	useStepDependencies()

	if (!isStoreRdy) return null

	return (
		<>
			<BookingProgress />
			<main>
				<Hero image={image} title={heroTitle} />
				<BookingStepNavigation>
					<>
						<LocationStep />
						<RoomConfigurationStep />
						<TravelPeriodStep />
						<RoomSelectionStep />
						<GuestDataStep />
						<BookingStep
							title={translate('step-06-title')}
							number="06"
							step="PAYMENT"
							summary={<div></div>}
						>
							<div></div>
						</BookingStep>
					</>
				</BookingStepNavigation>
			</main>
			<Footer />
		</>
	)
}
